import React from 'react'
import { Flex, TimerIcon, useTooltip } from 'vvs-uikit'
import { useTranslation } from 'contexts/Localization'
import useTheme from 'hooks/useTheme'
import dayjs from 'dayjs'
import { formatTimestampDuration } from 'views/xVvs/helpers'

export interface CountdownTooltipProps {
  timestamp: number
  tooltipText: string
  isFirst?: boolean
}

const CountdownTooltip: React.FunctionComponent<CountdownTooltipProps> = ({ timestamp, tooltipText, isFirst }) => {
  const { t, currentLanguage } = useTranslation()
  const { theme } = useTheme()
  const {
    targetRef: blockCountDownRef,
    tooltip: blockCountDownTooltip,
    tooltipVisible: blockCountDownTooltipVisible,
  } = useTooltip(
    t(`${tooltipText} %time%`, {
      time:
        currentLanguage.code === 'en'
          ? dayjs.duration(timestamp).format('M[M] D[d] H[h] m[m]')
          : formatTimestampDuration(Math.floor(timestamp / 1000), currentLanguage),
    }),
    {
      placement: isFirst ? 'top' : 'bottom',
    },
  )
  return (
    <Flex>
      <span ref={blockCountDownRef}>
        <TimerIcon color={theme.colors.primary} mt="2px" />
      </span>
      {blockCountDownTooltipVisible && blockCountDownTooltip}
    </Flex>
  )
}

export default CountdownTooltip
